// This module provides API call methods for SDN store API endpoint:
// https://stage-developer.sephora.com/specs/v1/docs/store.html

const olrToken = 'OLR_AUTH_TOKEN';
const bvToken = 'BV_AUTH_TOKEN';
const ufeToken = 'UFE_AUTH_TOKEN';

const { withSdnToken } = require('./sdnToken');
const addPaymentCreditCard = require('../onlineReservation/addPaymentCreditCard');
const bookReservation = require('../onlineReservation/bookReservation');
const cancelReservation = require('../onlineReservation/cancelReservation');
const createReservation = require('../onlineReservation/createReservation');
const deletePaymentCreditCard = require('../onlineReservation/deletePaymentCreditCard');
const getExperiences = require('../onlineReservation/getExperiences');
const getPaymentOptions = require('../onlineReservation/getPaymentOptions');
const getReservationByConfNumber = require('../onlineReservation/getReservationByConfNumber');
const getReservations = require('../onlineReservation/getReservations');
const updatePaymentCreditCard = require('../onlineReservation/updatePaymentCreditCard');
const updateReservation = require('../onlineReservation/updateReservation');


const getBrandsList = require('../reverseLookUp/getBrandsList');
const getProductIdLab = require('../reverseLookUp/getProductIdLab');
const getProductList = require('../reverseLookUp/getProductList');
const getProductSkuList = require('../reverseLookUp/getProductSkuList');
const getReverseLookUpSkuDetails = require('../reverseLookUp/getReverseLookUpSkuDetails');
const getMultiMatch = require('../reverseLookUp/getMultiMatch');
const getLABCodeDescription = require('../reverseLookUp/getLABCodeDescription');
const notificationsApi = require('../notifications');

module.exports = {
    addPaymentCreditCard,
    bookReservation: withSdnToken(bookReservation, olrToken),
    cancelReservation: withSdnToken(cancelReservation, olrToken),
    createReservation: withSdnToken(createReservation, olrToken),
    deletePaymentCreditCard,
    getExperiences: withSdnToken(getExperiences, olrToken),
    getPaymentOptions,
    getReservationByConfNumber: withSdnToken(getReservationByConfNumber, olrToken),
    getReservations: withSdnToken(getReservations, olrToken),
    updatePaymentCreditCard,
    updateReservation: withSdnToken(updateReservation, olrToken),

    getBrandsList: withSdnToken(getBrandsList, bvToken),
    getProductIdLab: withSdnToken(getProductIdLab, bvToken),
    getProductList: withSdnToken(getProductList, bvToken),
    getProductSkuList: withSdnToken(getProductSkuList, bvToken),
    getMultiMatch: withSdnToken(getMultiMatch, bvToken),
    getLABCodeDescription: withSdnToken(getLABCodeDescription, bvToken),
    getReverseLookUpSkuDetails,

    // Notification service
    notifyCurbsidePickup: withSdnToken(notificationsApi.curbsidePickupCheckin, ufeToken)
};
